// @core/api/endpoints/license/get_license_audit_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetLicenseAuditLogsResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get license audit logs
 * Returns the audit trail for a specific license, including all lifecycle events, configuration changes, and access attempts.
 */
export async function GetLicenseAuditLogs(
  license_id: string,
  options?: RequestOptions
): Promise<GetLicenseAuditLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/audit-logs`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.get<GetLicenseAuditLogsResponse>(requestPath, { ...requestOptions });
}
